class OrderStatusChecker {
  constructor() {
    this.intervalId = null;
    this.attempts = 0;
    this.maxAttempts = 5;
    this.pollingInterval = 3000;
  }

  init() {
    if (!this.shouldRun()) {
      return;
    }
    this.cleanCart();
    const params = new URLSearchParams(location.search);
    const draftId = params.get('draft_id');
    const storeHandle = params.get('store_name');

    if (!draftId || !storeHandle) {
      this.showError('Missing required parameters');
      return;
    }

    this.startPolling(storeHandle, draftId);
  }

  shouldRun() {
    return document.querySelector('.order-status-page-temporary') !== null;
  }

  cleanCart() {
	fetch('/cart/clear.js', { method: 'POST' })
  }

  startPolling(storeHandle, draftId) {
    // Initial check
    this.checkOrderStatus(storeHandle, draftId);

    // Set up polling
    this.intervalId = setInterval(() => {
      this.checkOrderStatus(storeHandle, draftId);
    }, this.pollingInterval);
  }

  async checkOrderStatus(storeHandle, draftId) {
    if (this.attempts >= this.maxAttempts) {
      this.showError('Order status check timed out. Please check back later or contact support.');
      this.stopPolling();
      return;
    }

    try {
      const response = await fetch(
        `https://wellvita-api.netlify.app/.netlify/functions/getOrderByDraftOrderId?store=${encodeURIComponent(storeHandle)}&draftOrderId=${encodeURIComponent(draftId)}`
      );
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      
      if (data?.status === 'completed') {
        this.handleOrderComplete(data);
      } else {
        this.attempts++;
      }
    } catch (error) {
      console.error('Error checking order status:', error);
      this.attempts++;
    }
  }

  async handleOrderComplete(data) {
    this.stopPolling();
    this.showMessage('Order confirmed!');
    try {
      await this.firePurchaseEvent(data);
    } catch (error) {
      console.error('Error in firePurchaseEvent:', error);
    }

    this.redirectToOrderStatusPage(data?.orderStatusPageUrl);
  }

  async firePurchaseEvent(orderData) {
    try {
      const orderId = orderData?.orderId || orderData?.draftOrderId || "";

      // Initialize tracking and fire purchase event
      const { CheckoutTracking } = await import('./tracking.js');
      const tracking = new CheckoutTracking();
      await tracking.init();
      tracking.purchase(orderId);
    } catch (error) {
      console.error("Error firing purchase event:", error);
    }
  }

  redirectToOrderStatusPage(url) {
    if (url) {
      window.location.href = url;
    } else {
      this.showError('Invalid order status URL');
    }
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  showMessage(message) {
    const msgElement = document.getElementById('msg');
    if (msgElement) {
      msgElement.textContent = message;
    }
  }

  showError(message) {
    console.error(message);
    this.showMessage(message);
  }
}

// Initialize the order status checker when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const orderStatusChecker = new OrderStatusChecker();
  orderStatusChecker.init();
});